'use es6';

import { createContext } from 'react';
export const MediaQueryStylesContext = /*#__PURE__*/createContext({
  hasInjectedGlobalStyles: false
});